import { render, staticRenderFns } from "./griNutritionAnalysisDetail.vue?vue&type=template&id=7d42c2ea&scoped=true"
import script from "./griNutritionAnalysisDetail.vue?vue&type=script&lang=js"
export * from "./griNutritionAnalysisDetail.vue?vue&type=script&lang=js"
import style0 from "./griNutritionAnalysisDetail.vue?vue&type=style&index=0&id=7d42c2ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d42c2ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d42c2ea')) {
      api.createRecord('7d42c2ea', component.options)
    } else {
      api.reload('7d42c2ea', component.options)
    }
    module.hot.accept("./griNutritionAnalysisDetail.vue?vue&type=template&id=7d42c2ea&scoped=true", function () {
      api.rerender('7d42c2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/manage/griNutritionAnalysisDetail.vue"
export default component.exports